const name = 'Fade';
const properties = {
    groups: ['animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        from: {
            type: 'object',
            properties: {
                opacity: {
                    type: 'number',
                    min: 0,
                    max: 1,
                },
                autoAlpha: {
                    type: 'number',
                    min: 0,
                    max: 1,
                },
            },
        },
        to: {
            type: 'object',
            properties: {
                opacity: {
                    type: 'number',
                    min: 0,
                    max: 1,
                },
                autoAlpha: {
                    type: 'number',
                    min: 0,
                    max: 1,
                    default: 1,
                },
            },
        },
    },
};
/**
 * Fade animation object
 * Defaults to fade in to opacity 1 with Sine.easeIn
 */
function animate(kit, elements, duration, delay, { from = {}, to = {}, ease = 'Sine.easeIn', ...params } = {}) {
    const sequence = kit.sequence(params);
    if (typeof to.opacity === 'undefined' &&
        typeof to.autoAlpha === 'undefined') {
        to.autoAlpha = properties.schema.to.properties.autoAlpha.default;
    }
    sequence.add(kit.animate('BaseFade', elements, duration, delay, {
        from,
        to,
        ease,
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=fade.js.map